import { defineEnum } from '@siclop/kstone-vue'

export enum LeaveRequestStatus {
  Draft = 0,
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Cancelled = 4,
  /** Approuvée par le responsable, en attente de la sur-validation (droit APPROVE_LEAVE_SECOND_LEVEL). */
  AwaitingSecondApproval = 5
}

export const useLeaveRequestStatusLabels = defineEnum({
  i18nPrefix: 'ksproject.enums.leaveRequestStatus',
  entries: {
    [LeaveRequestStatus.Draft]: { key: 'draft', label: 'Brouillon', tagType: 'info' },
    [LeaveRequestStatus.Pending]: { key: 'pending', label: 'En attente', tagType: 'warning' },
    [LeaveRequestStatus.Approved]: { key: 'approved', label: 'Approuvé', tagType: 'success' },
    [LeaveRequestStatus.Rejected]: { key: 'rejected', label: 'Refusé', tagType: 'danger' },
    [LeaveRequestStatus.Cancelled]: { key: 'cancelled', label: 'Annulé', tagType: 'info' },
    [LeaveRequestStatus.AwaitingSecondApproval]: {
      key: 'awaitingSecondApproval', label: 'En attente de validation RH/direction', tagType: 'warning'
    }
  }
})

